export const BOTTOM_AD_SHOWED = 'bottomAdShowed'
export const GOOGLE_DRIVE_ACCESS_TOKEN = 'GoogleDriveAccessToken'
export const HAS_USED_FOXIT_SIGN = 'hasUsedFoxitSign'